import { render } from "./fundDetails.vue?vue&type=template&id=28191e4e&scoped=true"
import script from "./fundDetails.vue?vue&type=script&lang=js"
export * from "./fundDetails.vue?vue&type=script&lang=js"

import "./fundDetails.vue?vue&type=style&index=0&id=28191e4e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28191e4e"]])

export default __exports__